import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from  '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class LocalStorage {
    private storageKey='ZIZ';
    constructor(){
        if(localStorage.getItem(this.storageKey)==null){
             localStorage.setItem(this.storageKey, JSON.stringify({}));
        }
    }
    getStorage(key) {
        var data = JSON.parse(localStorage.getItem(this.storageKey));
        if(data['"'+key+'"']){
        return data['"'+key+'"'];
        } else {
        return "";
        }
    }
    setStorage(key,value) {
      var data = JSON.parse(localStorage.getItem(this.storageKey));
      data['"'+key+'"'] = value;
      localStorage.setItem(this.storageKey, JSON.stringify(data));
    }
    removeStorage(key) {
      var data = JSON.parse(localStorage.getItem(this.storageKey));
      delete data['"'+key+'"']
      localStorage.setItem(this.storageKey, JSON.stringify(data));
    }
    clearAll() {
        localStorage.clear();
    }

}



// WEBPACK FOOTER //
// ./src/app/services/local-storage.ts